import React from "react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardFooter, CardHeader } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { cn } from "@/lib/utils";
function RecentPostsGrid() {
  const {
    posts,
    loading,
    error,
    refetch
  } = usePosts();
  if (loading) {
    return <div data-section-id="36210" className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="h-[400px] animate-pulse rounded-sm bg-muted/10" />)}
      </div>;
  }
  if (error) {
    return <div className="text-center text-muted-foreground">
        <p>Failed to load market data.</p>
        <button onClick={refetch} className="mt-2 font-mono text-xs underline hover:text-primary">
          RETRY_CONNECTION
        </button>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <p className="text-center text-muted-foreground font-serif">No active insights found.</p>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
      {posts.map((post, i) => <Link key={post.id} to={post.link || "#"} data-index={i} className="block h-full transition-transform duration-300 active:scale-[0.98]">
          <Card className="group flex h-full flex-col overflow-hidden rounded-sm border border-border/40 bg-card/30 backdrop-blur-[12px] p-0 shadow-none transition-all duration-300 hover:border-primary/60 hover:bg-card/50">
            <div className="w-full overflow-hidden">
              <AspectRatio ratio={16 / 9}>
                {post.featuredImage ? <img src={post.featuredImage} alt={post.title} className="h-full w-full object-cover opacity-80 transition-all duration-700 group-hover:scale-105 group-hover:opacity-100" /> : <div className="flex h-full w-full items-center justify-center bg-muted/20 text-muted-foreground transition-all duration-500 group-hover:bg-muted/30">
                    <span className="font-mono text-xs tracking-widest">NO_VISUAL</span>
                  </div>}
              </AspectRatio>
            </div>

            <CardHeader className="flex-grow space-y-3 px-6 pt-6 pb-2">
              <h3 className="line-clamp-2 text-2xl font-extrabold leading-tight text-foreground tracking-tighter font-sans">
                {post.title}
              </h3>
              <div className="line-clamp-3 text-[14px] leading-relaxed text-muted-foreground font-serif" dangerouslySetInnerHTML={{
            __html: post.excerpt || ""
          }} />
            </CardHeader>

            <CardFooter className="px-6 pb-6 pt-4">
              <span className="relative inline-block font-mono text-xs font-medium uppercase tracking-widest text-primary after:absolute after:bottom-0 after:left-0 after:h-[1px] after:w-0 after:bg-primary after:transition-all after:duration-300 group-hover:after:w-full">
                ACCESS_REPORT
              </span>
            </CardFooter>
          </Card>
        </Link>)}
    </div>;
}
export default function RecentPosts() {
  const wp_query_params = {
    per_page: 3,
    orderby: "date",
    order: "desc"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="market-insight" className="bg-background text-foreground py-24" style={{
    '--primary': 'hsl(42 71% 97%)',
    '--accent': 'hsl(26 91% 37%)',
    '--secondary': 'hsl(43 59% 90%)',
    '--secondary-foreground': 'hsl(24 10% 10%)',
    '--muted': 'hsl(43 59% 90%)',
    '--border': 'hsl(24 10% 10%)'
  } as React.CSSProperties}>
      <div className="container mx-auto px-4">
        <div className="mb-12 flex flex-col items-start justify-between gap-4 md:flex-row md:items-end border-l-2 border-primary/30 pl-6">
          <div className="max-w-2xl">
            <h2 className="text-3xl font-extrabold tracking-tighter text-foreground sm:text-5xl font-sans uppercase">News</h2>
            <p className="mt-4 text-lg text-muted-foreground font-serif">Insights from the frontlines of AI infrastructure and digital investment. Discover how our leadership engages with global partners, investors, and innovators to shape the next phase of data center and AI ecosystem growth.</p>
          </div>
        </div>

        <PostsProvider wp_query={{
        per_page: 8,
        orderby: "date",
        order: "desc"
      }}>
          <RecentPostsGrid />
        </PostsProvider>
      </div>
    </section>;
}